import { useEffect, useState } from "react";

function diffParts(targetMs) {
  const now = Date.now();
  let delta = Math.max(0, targetMs - now);
  const days = Math.floor(delta / (1000 * 60 * 60 * 24));
  delta -= days * 1000 * 60 * 60 * 24;
  const hours = Math.floor(delta / (1000 * 60 * 60));
  delta -= hours * 1000 * 60 * 60;
  const minutes = Math.floor(delta / (1000 * 60));
  delta -= minutes * 1000 * 60;
  const seconds = Math.floor(delta / 1000);
  return { days, hours, minutes, seconds, done: targetMs - now <= 0 };
}

export default function Countdown({ targetISO }) {
  const targetMs = new Date(targetISO).getTime();
  const [t, setT] = useState(() => diffParts(targetMs));

  useEffect(() => {
    const id = setInterval(() => setT(diffParts(targetMs)), 1000);
    return () => clearInterval(id);
  }, [targetMs]);

  const cell = (value, label, testid) => (
    <div className="flex flex-col items-center" data-testid={testid}>
      <div className="font-serif-display text-[#4A5346] text-6xl sm:text-7xl md:text-8xl leading-none">
        {String(value).padStart(2, "0")}
      </div>
      <div className="label-eyebrow mt-4">{label}</div>
    </div>
  );

  if (t.done) {
    return (
      <div className="text-center" data-testid="countdown-complete">
        <p className="font-serif-display italic text-3xl sm:text-4xl text-[#4A5346]">
          The day has arrived.
        </p>
      </div>
    );
  }

  return (
    <div
      className="grid grid-cols-2 md:grid-cols-4 gap-y-12 gap-x-6 sm:gap-x-12"
      data-testid="countdown-timer"
    >
      {cell(t.days, "Days", "countdown-days")}
      {cell(t.hours, "Hours", "countdown-hours")}
      {cell(t.minutes, "Minutes", "countdown-minutes")}
      {cell(t.seconds, "Seconds", "countdown-seconds")}
    </div>
  );
}
